<script>
    import Navbar from './Components/bootstrap/Navbar.svelte';
    import title from './constantes.js'
</script>

<svelte:head>
	<title>{title}</title>
</svelte:head>


<header>
    <div class="w-75 mx-auto">
        <a class="logo custom-logo align-items-center" href="/" title="Ir a ">
            <img src="./images/logo.png" alt="Logo de {title}" title="{title}" class="float-start mr-2" height="60" />
        </a>
    </div>
    <div class="">
        <div class="w-75 mx-auto">
            <Navbar />
        </div>
    </div>
</header>
<style>
    header{
        border-bottom: 6px solid #01479e;
    }
</style>
